<template>
    <section class="content">
        <template v-for="alert in alerts">
            <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
                <h4>
                    <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
                    <i class="icon fa fa-ban" v-else></i>
                    {{'alert_'+alert.type | translate}}!</h4>
                <p v-if="alert.type !== 'danger'">
                    {{alert.message}}
                </p>
                <ul v-else>
                    <li v-for="e in alert.message">
                        {{e}}
                    </li>
                </ul>
            </b-alert>
        </template>
        <file-upload @alert="alert" @toggle="loading = !loading"></file-upload>
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title"><i class="fa fa-files-o mr-5"></i>{{'files' | translate}}</h3>
                <div class="box-tools pull-right">
                    <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
                    <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
                </div>
            </div>
            <div class="box-body">
                <div class="table-responsive" v-if="files.length > 0">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th class="col-xs-2">{{'created' | translate}}</th>
                            <th class="col-xs-4">{{'title' | translate}}</th>
                            <th>{{'type' | translate}}</th>
                            <th>{{'size' | translate}}</th>
                            <th>{{'path' | translate}}</th>
                            <th>{{'edit' | translate}}</th>
                            <th>{{'delete' | translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="file in files">
                            <td>{{file.id}}</td>
                            <td class="small">{{file.created | orderDate}}<span class="text-muted"><i class="fa fa-clock-o mr-5 ml-5"></i>{{file.created| orderDate(true)}}</span></td>
                            <td>
                                <template v-if="edit[file.id]">
                                    <div class="col-xs-8">
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="title..." v-model="file.original_title"/>
                                            <div class="input-group-btn">
                                                <button @click="sendData('PUT', file)" type="button" class="btn btn-success"><i class="fa fa-save mr-5"></i>{{'submit' | translate}}</button>
                                            </div>
                                        </div> <br/>
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="Sub-title..." v-model="file.original_sub"/>
                                            <div class="input-group-btn">
                                                <button @click="sendData('PUT', file)" type="button" class="btn btn-success"><i class="fa fa-save mr-5"></i>{{'submit' | translate}}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-4">
                                        <button @click="refresh()" class="btn btn-sm btn-app btn-danger"><i class="fa fa-ban"></i>{{'cancel' | translate}}</button>
                                    </div>
                                </template>
                                <template v-else>
                                    {{file.title}} <br/> <small>{{file.subtitle}}</small>
                                </template>
                            </td>
                            <td>{{file.type}}</td>
                            <td>{{file.size}} Kb</td>
                            <td><a :href="file.path" target="_blank"><i class="fa fa-cloud-download mr-5"></i>{{file.title}}</a></td>
                            <td><button class="btn btn-warning no-margin" @click="editFile(file.id)"><i class="fa fa-edit mr-5"></i>{{'edit' | translate}}</button></td>
                            <td><button class="btn btn-danger no-margin" @click="sendData('DELETE', file)"><i class="fa fa-trash-o mr-5"></i>{{'delete' | translate}}</button></td>
                         </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    No files to show
                </div>
            </div>
        </div>
        <div class="overlay" v-show="loading">
            <img class="loading-gif" src="/static/img/blabla.svg"/>
        </div>
    </section>
</template>
<script>
  import FileUpload from '../tools/FileUpload.vue'
  export default {
    data () {
      return {
        files: [],
        edit: [],
        alerts: [],
        loading: false
      }
    },
    components: {
      fileUpload: FileUpload
    },
    computed: {
    },
    methods: {
      sendData (method, data = {note: this.noteBody}) {
        let extra = ''
        if (method === 'PUT' || method === 'DELETE') {
          extra = '/' + data.id
          data.title = data.original_title
          data.sub_title = data.original_sub
          this.loading = true
        }
        API({method: method, url: 'files' + extra, data: data})
          .then(response => {
              this.loading = false
              this.alerts.push({dismiss: 4, type: 'success', message: 'Success', icon: 'icon fa fa-check', show: true})
              this.refresh(method === 'PUT' ? data.id : true)
            })
          .catch(error => {
              this.alerts.push({dismiss: 4, type: 'danger', message: [error.response.data.message], icon: 'icon fa fa-check', show: true})
              this.loading = false
            })
      },
      editFile (id) {
        this.edit[id] = true
        this.edit = [...this.edit]
      },
      alert (value) {
        this.alerts.push(value)
        this.refresh()
      },
      refresh (flag) {
        API.get('files')
          .then(response => {
              this.files = response.data
              if (flag) {
                this.edit[flag] = false
                this.files.forEach(n => {
                  n.original_title = n.title
                  n.original_sub = n.subtitle
                })
              } else {
                this.files.forEach(n => {
                  this.edit[n.id] = false
                  n.original_title = n.title
                  n.original_sub = n.subtitle
                })
              }
            })
      }
    },
    mounted () {
      this.$nextTick(function () {
        this.refresh()
      })
    }
  }
</script>

<style>
    .overlay {
        z-index: 50;
        background: rgba(33,34,40,.75);
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 110%;
    }
    .overlay > .fa {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: currentColor;
        font-size: 2rem;
        opacity: 0.65;
    }
</style>
<style scoped>
    .loading-gif {
        display: block;
        width: 5%;
        top: 42%;
        left: 50%;
        position: fixed;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Uploader.vue